const templates = [
    {
        id: 1,
        slideImage: 'images/cb-slide1.png'
    },
    {
        id: 2,
        slideImage: 'images/cb-slide2.png'
    },
    {
        id: 3,
        slideImage: 'images/cb-slide3.png'
    },
    {
        id: 4,
        slideImage: 'images/cb-slide4.png'
    },
    {
        id: 5,
        slideImage: 'images/cb-slide5.png'
    },

    {
        id: 6,
        slideImage: 'images/cb-slide6.png'
    },

    {
        id: 7,
        slideImage: 'images/cb-slide7.png'
    },
    {
        id: 8,
        slideImage: 'images/cb-slide8.png'
    },
    {
        id: 9,
        slideImage: 'images/cb-slide9.png'
    }

]

export default templates